import { useLocation } from 'react-router-dom';

import { clearFirebase, getPath, Path, RedirectState, useFlags } from '@neo.tax/shared';
import { env } from '@neo.tax/shared/utils';
import { isPreviewEnvironment } from '@neo.tax/shared/utils/environment.utils';

export const useBaseRedirect = (): RedirectState => {
  const flags = useFlags();
  // Maintenance mode guards the release branch's own deploy; previews run on separate backends and stay usable.
  const enableMaintenanceMode = flags.enableMaintenanceMode && !isPreviewEnvironment(env.REACT_APP_NEO_TAX_ENV);

  const location = useLocation();
  const isInMaintenancePage = location.pathname === getPath({ path: Path.MAINTENANCE_MODE });

  // If the user is in the maintenance page and the maintenance mode is disabled, redirect to login which redirect to the correct page
  if (isInMaintenancePage && !enableMaintenanceMode) {
    return { redirectTo: getPath({ path: Path.LOGIN }), isLoading: false };
  }

  // If the user is not in the maintenance page and the maintenance mode is enabled, redirect to the maintenance page
  if (enableMaintenanceMode) {
    clearFirebase();
    if (isInMaintenancePage) {
      return { isLoading: false };
    }
    return { redirectTo: getPath({ path: Path.MAINTENANCE_MODE }), isLoading: false };
  }

  // If the user is not in the maintenance page and the maintenance mode is disabled, do nothing
  return { isLoading: false };
};
